import {useCallback, useState} from 'react';
import classNames from 'classnames';

import {Avatar} from '../../../atoms/avatar';
import {FilePreviewActionDownload, ImagePreview} from '../../../organisms/file-preview';
import {TypographySize, useTypography} from '../../../hooks/typography';

import type {ProfileHeaderProps} from './types';
import {StatusIcon} from './status-icon';

import {AvatarPreviewTitle} from './avatar-preview-title';
import styles from './styles.module.css';

export const ProfileHeader = (props: ProfileHeaderProps) => {
    const [isAvatarPreviewOpen, setAvatarPreviewOpen] = useState(false);
    const [usernameTypoCls, body100Cls, roleTypoCls] = useTypography([
        {
            size: TypographySize.Heading6,
        },
        {
            size: TypographySize.BodyL,
        },
        {
            size: TypographySize.BodyS,
        },
    ]);
    const handleAvatarClick = useCallback(() => setAvatarPreviewOpen(true), []);
    const handleAvatarPreviewClose = useCallback(() => setAvatarPreviewOpen(false), []);

    return (
        <div className={styles.profileHeader}>
            <div
                data-testid='profile-header-avatar'
                role='button'
                className={classNames(styles.avatarWrapper, {
                    [styles.avatarWithPreview]: Boolean(props.avatarUrlLarge),
                })}
                onClick={handleAvatarClick}
            >
                <Avatar size={120} src={props.avatarUrl} username={props.username} />
                <StatusIcon className={styles.statusIcon} status={props.status} />
            </div>
            <div data-testid='profile-header-username' className={classNames(usernameTypoCls, styles.username)}>{props.username}</div>
            {props.position && <div data-testid='profile-header-position' className={classNames(styles.position, body100Cls)}>{props.position}</div>}
            {props.role && <span data-testid='profile-header-role' className={classNames(styles.role, roleTypoCls)}>{props.role}</span>}
            {props.customStatus && <div data-testid='profile-header-custom-status' className={classNames(body100Cls, styles.customStatus)}>{props.customStatus}</div>}
            {props.avatarUrlLarge && (
                <ImagePreview
                    show={isAvatarPreviewOpen}
                    width={256}
                    height={256}
                    actions={<FilePreviewActionDownload downloadUrl={props.avatarUrlLarge} />}
                    imageUrl={props.avatarUrlLarge}
                    onClose={handleAvatarPreviewClose}
                    title={<AvatarPreviewTitle avatarUrl={props.avatarUrl} userName={props.username} position={props.position} />}
                />
            )}
        </div>
    );
};
